import { helper } from '@ember/component/helper';

export function decodeHtml([value]) {
  if (typeof value !== 'string' || value === '') return value;
  const el = document.createElement('textarea');
  el.innerHTML = value;
  return el.value;
}

export default helper(decodeHtml);
